export function OptionsSalaDeAula() {
  return [
    { label: "Sim", value: "T" },
    { label: "Não", value: "F" },
  ];
}
